<template>
  <header class="global-header">
    <div class="global-header__title">
      <span
        id="burger"
        class="global-header__burger"
        v-on:click="this.addActive"
      ></span>
      <a
        href="https://www.citroen.jp/home.html"
        target="_blank"
        class="global-header__title__item"
        >CITROËN <br /><span style="color: #9d0605;"> JAPON</span></a
      >
    </div>
    <span
      id="overlay"
      class="global-header__overlay"
      v-on:click="this.removeActive"
    ></span>
    <span
      id="overlay_black"
      class="global-header__overlay--black"
      v-on:click="this.removeActive"
      v-on:touchmove="this.removeActive"
    ></span>
    <div class="global-header__shoulder-nav">
      <ul class="global-header__shoulder-nav__wrap">
        <li class="global-header__shoulder-nav__item">
          <a
            href="https://www.citroen.jp/home.html"
            target="_blank"
            class="global-header__shoulder-nav__item__link--logo"
            ><img
              src="../assets/images/citroen_logo.png"
              alt=""
              class="global-header__shoulder-nav__item__link--logo__img"
          /></a>
        </li>
      </ul>
    </div>
    <div class="global-header__nav__wrapper">
      <div class="global-header__nav__logo">
        <a href="https://www.citroen.jp/home.html" target="_blank"
          ><img src="../assets/images/citroen_logo.png" alt=""
        /></a>
      </div>
      <nav id="global-header__nav" class="global-header__nav">
        <ul class="global-header__nav__wrap">
          <li class="global-header__nav__item pc-only">
            <a
              href="https://www.citroen.jp/citroen-brand/menu2/#sticky"
              target="_blank"
              class="global-header__nav__item__link"
              >シトロエンブランド</a
            >
          </li>
          <li class="global-header__nav__item">
            <a
              href="https://web.citroen.jp/dealers-list/"
              onclick="kpp_tracking_event('Header','Dealer locator','Redirection::External',false,false,'newgtm');"
              target="_blank"
              class="global-header__nav__item__link"
              >ディーラー一覧</a
            >
          </li>
          <li class="global-header__nav__item sp-only">
            <span class="global-header__nav__parent">MODELS</span>
            <ul class="global-header__nav__lower">
              <li class="global-header__nav__item">
                <a
                  href="https://www.citroen.jp/car/c3/"
                  onclick="kpp_tracking_event('Header','common','Redirection::Showroom::1CB6A5',false,false,'newgtm');"
                  target="_blank"
                  class="global-header__nav__item__link"
                  >C3</a
                >
              </li>
              <li class="global-header__nav__item">
                <a
                  href="https://www.citroen.jp/car/c3-aircross/"
                  onclick="kpp_tracking_event('Header','common','Redirection::Showroom::1CW8AF',false,false,'newgtm');"
                  target="_blank"
                  class="global-header__nav__item__link"
                  >C3 AIRCROSS SUV</a
                >
              </li>
              <li class="global-header__nav__item">
                <a
                  href="https://www.citroen.jp/car/grand-c4-spacetourer/"
                  onclick="kpp_tracking_event('Header','common','Redirection::Showroom::1CH5CL',false,false,'newgtm');"
                  target="_blank"
                  class="global-header__nav__item__link"
                  >GRAND C4 SPACETOURER</a
                >
              </li>
              <li class="global-header__nav__item">
                <a
                  href="https://www.citroen.jp/car/c5aircross/"
                  onclick="kpp_tracking_event('Header','common','Redirection::Showroom::1CCESY',false,false,'newgtm');"
                  target="_blank"
                  class="global-header__nav__item__link"
                  >C5 AIRCROSS SUV</a
                >
              </li>
            </ul>
          </li>
          <li class="global-header__nav__item sp-only">
            <a
              href="https://style.citroen.jp/"
              onclick="kpp_tracking_event('Header','Configurator','Redirection::External',false,false,'newgtm');"
              target="_blank"
              class="global-header__nav__item__link"
              >コンフィギュレーター</a
            >
          </li>
          <li class="global-header__nav__item sp-only">
            <a
              href="https://www.citroen.jp/webcatalog/"
              target="_blank"
              class="global-header__nav__item__link"
              >WEBカタログ</a
            >
          </li>
          <li class="global-header__nav__item sp-only">
            <a
              href="https://web.citroen.jp/support/testdrive/"
              onclick="kpp_tracking_event('Header','common','Redirection::Forms::Testdrive_Request',false,false,'newgtm');"
              target="_blank"
              class="global-header__nav__item__link"
              >試乗申込み</a
            >
          </li>
          <li class="global-header__nav__item sp-only">
            <a
              href="https://krs.bz/pcj/m/ct_appointment"
              onclick="kpp_tracking_event('Header','common','Redirection::Forms::Appointment_Request',false,false,'newgtm');"
              target="_blank"
              class="global-header__nav__item__link"
              >商談申込み</a
            >
          </li>
          <li class="global-header__nav__item sp-only">
            <a
              href="https://www.citroen.jp/citroen-brand/menu2/#sticky"
              target="_blank"
              class="global-header__nav__item__link"
              >シトロエンブランド</a
            >
          </li>
          <li class="global-header__nav__item sp-only">
            <a
              href="https://www.citroen.jp/"
              target="_blank"
              class="global-header__nav__item__link"
              >TOP</a
            >
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>
<script>
export default {
  name: "global-header",
  data: function () {
    return {};
  },
  methods: {
    addActive: function () {
      this.overlay.classList.add("is-active");
      this.overlay_black.classList.add("is-active");
      this.global_nav.classList.add("is-active");
      document.body.classList.add("is-fixed");
      this.heightResize();
    },
    heightResize: function () {
      var windowHeight = window.innerHeight;
      var navWrapHeight = this.global_nav_wrap.clientHeight;
      if (navWrapHeight > windowHeight) {
        this.global_nav.setAttribute(
          "style",
          "height:" + window.innerHeight + "px"
        );
      } else {
        this.global_nav.removeAttribute("style");
      }
    },
    removeActive: function () {
      this.overlay.classList.remove("is-active");
      this.overlay_black.classList.remove("is-active");
      this.global_nav.classList.remove("is-active");
      document.body.classList.remove("is-fixed");
    },
  },
  mounted: function () {
    this.urger = document.getElementById("burger");
    this.overlay = document.getElementById("overlay");
    this.overlay_black = document.getElementById("overlay_black");
    this.global_nav = document.getElementById("global-header__nav");
    this.global_nav_wrap = document.getElementsByClassName(
      "global-header__nav__wrap"
    )[0];
    window.addEventListener("resize", this.heightResize);
  },
};
</script>
<style lang="scss">
.global-header__nav__logo img {
  padding-bottom: 0;
}
</style>
